/**
 * FlowsIcon — 흐름(FLOWS) 모듈 커스텀 아이콘
 *
 * 방향성을 표현하는 화살표. 세 꼭짓점 둥글게, 가운데 V는 날카롭게.
 */

interface FlowsIconProps {
  className?: string;
}

export function FlowsIcon({ className = "w-5 h-5" }: FlowsIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.2 3.5 C10.8 0.8, 13.2 0.8, 13.8 3.5 L19.2 17 C20.2 19.5, 18.8 21, 17 19.5 L12 15.4 L7 19.5 C5.2 21, 3.8 19.5, 4.8 17 Z"
        fill="currentColor"
      />
    </svg>
  );
}
